<div class="wrapper">
  <div class="navbar-custom">
    <header-component (toggleSidenavEmitter)="sidenav = $event" />
  </div>
  <div class="leftside-menu menuitem-active">
    <sidebar-component [sidenav]="sidenav" />
  </div>

  <div class="content-page">
    <div class="content">
      <div class="container-fluid">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
